module.exports = __webpack_public_path__ + "assets/images/TTD50.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/TTD50.png
// module id = 1437
// module chunks = 1